import { curry } from 'lodash-es';

export const equals = curry((value1, value2) => value1 === value2);
